import React from "react";
import { Lock } from "lucide-react";

// one distinctive colour per section (icon tile background)
const TONE = {
  overview: "from-indigo-500 to-violet-600", enquiries: "from-sky-500 to-cyan-500", inquiries: "from-blue-500 to-indigo-500", quotes: "from-amber-500 to-orange-500",
  "service-requests": "from-orange-500 to-red-500", applications: "from-emerald-500 to-teal-500", "career-apps": "from-lime-500 to-green-600", people: "from-fuchsia-500 to-pink-600",
  team: "from-teal-500 to-cyan-600", letters: "from-rose-500 to-pink-500", idcards: "from-purple-500 to-indigo-600", salary: "from-yellow-500 to-amber-600",
  payments: "from-green-500 to-emerald-600", products: "from-cyan-500 to-blue-600", signature: "from-slate-500 to-slate-700", "email-setup": "from-red-500 to-rose-600",
  holidays: "from-pink-500 to-rose-500", leave: "from-violet-500 to-purple-600", training: "from-blue-600 to-sky-500",
};

/** Enterprise landing grid for /admin: white rounded cards, colourful icon tiles, same navigation as the tab strip. */
export const AdminDashboard = ({ tabs, sections, onOpen, userName }) => (
  <section data-testid="admin-dashboard">
    <div className="mb-6 sm:mb-8">
      <p className="text-[11px] tracking-[0.3em] uppercase text-nx-gold">Team Tracker</p>
      <h1 className="text-2xl sm:text-3xl font-semibold text-white mt-1">Good {new Date().getHours() < 12 ? "morning" : new Date().getHours() < 17 ? "afternoon" : "evening"}{userName ? `, ${(userName.replace(/^(dr|mr|mrs|ms)\.?\s+/i, "").split(" ")[0])}` : ""}</h1>
      <p className="text-sm text-slate-400 mt-1">Choose a section to get started.</p>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4" data-testid="admin-dashboard-grid">
      {tabs.map((t, i) => {
        const Icon = t.icon;
        const locked = !sections[t.id];
        const m = /^(.*?)(?:\s*\((.+)\))?$/.exec(t.label) || [];
        const title = m[1] || t.label, badge = m[2];
        return (
          <button key={t.id} onClick={() => onOpen(t.id, locked)} aria-disabled={locked} data-testid={`dash-card-${t.id}`}
            style={{ animationDelay: `${i * 35}ms` }}
            className={`group relative text-left bg-white rounded-2xl p-4 sm:p-5 min-h-[128px] sm:min-h-[150px] flex flex-col justify-between shadow-[0_8px_30px_rgba(0,0,0,0.25)] transition-transform duration-200 motion-safe:animate-[fadeUp_.5s_ease_both] ${locked ? "opacity-60 cursor-not-allowed" : "hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(0,0,0,0.35)]"}`}>
            <div className="flex items-start justify-between gap-2">
              <span className={`inline-flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-xl text-white bg-gradient-to-br ${TONE[t.id] || "from-slate-500 to-slate-700"} shadow-md`}>
                {locked ? <Lock size={20} /> : <Icon size={22} />}
              </span>
              {badge && <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-slate-900 text-white" data-testid={`dash-badge-${t.id}`}>{badge}</span>}
            </div>
            <div>
              <p className="text-sm sm:text-[15px] font-semibold text-slate-900 leading-snug break-words">{title}</p>
              <p className="text-[11px] text-slate-500 mt-0.5">{locked ? "Not available for your role" : "Open section"}</p>
            </div>
          </button>
        );
      })}
    </div>
  </section>
);
